import { apiGet } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import { useEffect, useState } from "react";

const ProjectDropdown = (props) => {
  const {
    onChange,
    ProjectsOption,
    defaultValue,
    showAllProjectOption = false,
    disabledDropdown,
  } = props;

  const [projects, setProjects] = useState(ProjectsOption || []);

  const getAllProjects = async () => {
    if (!ProjectsOption || ProjectsOption.length === 0) {
      try {
        const response = await apiGet("/v1/projects", false);
        let projectOptions = response.data.map((project) => ({
          id: project.id,
          label: project.propertyName,
        }));

        // Add "All Projects" at the top if enabled
        if (showAllProjectOption) {
          projectOptions = [
            { id: "all", label: "All Projects" },
            ...projectOptions,
          ];
        }

        setProjects(projectOptions);
      } catch (error) {
        console.error("Error fetching projects", error);
      }
    } else {
      setProjects(ProjectsOption);
    }
  };

  useEffect(() => {
    getAllProjects();
  }, [ProjectsOption]);

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      placeholder="Select property"
      options={projects}
      onChange={(value) => onChange(value)}
      borderColor="#ED850C"
      disabled={true}
      width={"200px"}
      height={"33px"}
      disabledDropdown={disabledDropdown}
    />
  );
};

export default ProjectDropdown;
